import * as Sentry from "@sentry/react";

if (import.meta.env.MODE === "production") {
  Sentry.init({
    environment: import.meta.env.MODE,
    dsn: "https://fe468b325d2411bf1168b522b7f44938@o445277.ingest.us.sentry.io/4511063704076288",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Enable logs to be sent to Sentry
    enableLogs: true,
    denyUrls: [
      "https://rsms.me",
      "https://fonts.googleapis.com",
      "https://www.googleapis.com/identitytoolkit",
      "https://coursebook.app/assets",
      "https://securetoken.googleapis.com",
      "https://app.lemonsqueezy.com",
    ],
    integrations: [
      Sentry.feedbackIntegration({
        colorScheme: "system",
        autoInject: false,
      }),
    ],
  });
}
